var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#EEFDF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.045 17.7601L21.795 14.4751C21.5566 14.3261 21.2811 14.2471 21 14.2471C20.7189 14.2471 20.4434 14.3261 20.205 14.4751L14.955 17.7601C14.7399 17.8945 14.5624 18.0813 14.4391 18.303C14.3158 18.5246 14.2508 18.7739 14.25 19.0276V26.2501C14.25 26.6479 14.408 27.0294 14.6893 27.3107C14.9706 27.592 15.3522 27.7501 15.75 27.7501H26.25C26.6478 27.7501 27.0294 27.592 27.3107 27.3107C27.592 27.0294 27.75 26.6479 27.75 26.2501V19.0276C27.7492 18.7739 27.6842 18.5246 27.5609 18.303C27.4376 18.0813 27.2601 17.8945 27.045 17.7601ZM23.25 22.5001H21.75V24.0001C21.75 24.199 21.671 24.3898 21.5303 24.5304C21.3897 24.6711 21.1989 24.7501 21 24.7501C20.8011 24.7501 20.6103 24.6711 20.4697 24.5304C20.329 24.3898 20.25 24.199 20.25 24.0001V22.5001H18.75C18.5511 22.5001 18.3603 22.4211 18.2197 22.2804C18.079 22.1398 18 21.949 18 21.7501C18 21.5512 18.079 21.3604 18.2197 21.2197C18.3603 21.0791 18.5511 21.0001 18.75 21.0001H20.25V19.5001C20.25 19.3012 20.329 19.1104 20.4697 18.9697C20.6103 18.8291 20.8011 18.7501 21 18.7501C21.1989 18.7501 21.3897 18.8291 21.5303 18.9697C21.671 19.1104 21.75 19.3012 21.75 19.5001V21.0001H23.25C23.4489 21.0001 23.6397 21.0791 23.7803 21.2197C23.921 21.3604 24 21.5512 24 21.7501C24 21.949 23.921 22.1398 23.7803 22.2804C23.6397 22.4211 23.4489 22.5001 23.25 22.5001Z",
    fill: "#1ECCB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.1646d064694b7efcce8970bf0bc2cf65.svg";
export { ForwardRef as ReactComponent };